export enum PaxType {
  ADULTS = 'Adult',
  CHILDREN = 'Child',
  INFANTS = 'Infant'
}
